var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex flex-column jc-center ai-center"},[_c('div',{staticClass:"tel flex jc-centr ai-center"},[_c('img',{staticClass:"icon",attrs:{"src":require("../../images/tel.png")}}),_c('div',{staticClass:"txt"},[_vm._v("服务热线: "+_vm._s(_vm.sysPhone))])]),_c('div',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.recordNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }